import { computed, inject } from '@angular/core';
import {
  callApiMethod,
  CallStateSlice,
  setError,
  setLoaded,
  setLoading,
  withExport,
  withResourceState,
} from '@kinet-open-network/client/shared/data-access/state';
import {
  IServPackageOffer,
  ServiceType,
} from '@kinet-open-network/shared/data-access/model';
import {
  patchState,
  signalStore,
  signalStoreFeature,
  type,
  withComputed,
  withMethods,
  withState,
} from '@ngrx/signals';
import { ServPackagesService } from '../services/serv-packages.service';

interface OffersOptionsStateSlice {
  offers: IServPackageOffer[];
}

function withOffersOptions() {
  return signalStoreFeature(
    {
      state: type<CallStateSlice>(),
    },
    withState<OffersOptionsStateSlice>({ offers: [] }),
    withComputed((store) => ({
      offersOptions: computed(() =>
        store.offers().map((offer) => ({
          label: offer.name,
          value: offer.offerId,
        })),
      ),
    })),
    withMethods((store, service = inject(ServPackagesService)) => ({
      loadOffersOptions: (type: ServiceType) => {
        patchState(store, setLoading());
        return callApiMethod(() => service.getOffers(type), {
          next: (options) =>
            patchState(store, { offers: options }, setLoaded()),
          error: (err) => patchState(store, setError(err), setLoaded()),
        });
      },
    })),
  );
}

export const ServPackagesStore = signalStore(
  { protectedState: false },
  withResourceState(ServPackagesService),
  withExport(ServPackagesService),
  withOffersOptions(),
);
